module.exports = __webpack_public_path__ + "img/square-up-right.54368ed3.svg";